"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = exports.SubmitButton = exports.StyledInput = exports.Wrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Inputstyle__Wrapper",
  componentId: "sc-1oboklm-0"
})(["position:relative;"]);
exports.Wrapper = Wrapper;
var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "Inputstyle__StyledInput",
  componentId: "sc-1oboklm-1"
})(["", ""], function (_ref) {
  var disabled = _ref.disabled,
    ghost = _ref.ghost,
    button = _ref.button,
    input = _ref.theme.input,
    light = _ref.light;
  return (0, _styledComponents.css)(["background-color:", ";border-radius:", ";border:", ";color:", ";display:block;font-size:", ";line-height:", ";padding:", ";width:100%;&::placeholder{color:", ";}", " ", " ", ""], input.backgroundColor, input.borderRadius, light ? 'none' : input.border, input.textColor, input.fontSize, input.lineHeight, input.padding, input.placeholderColor, disabled && (0, _styledComponents.css)(["cursor:not-allowed;color:", ";background-color:", ";"], input.textColorDisabled, !light ? input.backgroundColorDisabled : input.backgroundColorDisabledLight), ghost && (0, _styledComponents.css)(["border:0;border-radius:0;background-color:transparent;border-bottom:", ";"], input.borderBottomGhost), button && (0, _styledComponents.css)(["", ""], (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          padding-right: ", ";\n        "])), input.buttonWidth)));
});
exports.StyledInput = StyledInput;
var SubmitButton = _styledComponents.default.button.withConfig({
  displayName: "Inputstyle__SubmitButton",
  componentId: "sc-1oboklm-2"
})(["cursor:pointer;display:flex;height:100%;justify-content:center;padding:0;position:absolute;right:0;top:0;width:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.input.buttonWidth;
});
exports.SubmitButton = SubmitButton;
var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Inputstyle__IconWrapper",
  componentId: "sc-1oboklm-3"
})(["right:", ";position:absolute;top:50%;z-index:2;line-height:0;transform:translateY(-50%);"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.sm;
});
exports.IconWrapper = IconWrapper;